export enum PlatformDataEvents {
  VIEW_ITEM_LIST = "view_item_list",
  VISIT = "visit",
  CONVERSION = "conversion",
  BD4_INTERACTION = "bd4Interaction",
  CCM_COOKIEGO = "CCM_cookieGO",
  TEALIUM_COOKIEGO = "Tealium_cookieGO",
  GTM_JS = "gtm.js",
  GTM_DOM = "gtm.dom",
  GTM_LOAD = "gtm.load",
  SMARTSEER_RECOVIEW = "smartseerRecoview",
  USER_INTERACTION = "userInteraction",
  GA_EVENT = "gaEvent",
}
